import { CSSProperties } from 'react';

export const uploadZonestyleProgressText = {
    maxWidth: '70%',
    textAlign: 'left',
    position: 'relative',
};

export const uploadZonestyleProgressStyle = {
    fontFamily: "'Poppins'",
    fontStyle: 'normal',
    fontWeight: `bold`,
    lineHeight: '24px',
    fontFeatureSettings: "'pnum' on, 'lnum' on",
    color: `#3A3A3A`,
    whiteSpace: 'nowrap',
    textWrap: 'wrap',
    overflowWrap: 'anywhere',
};

export const uploadZonestyleStatusUpload = {
    fontFamily: "'Poppins'",
    fontStyle: 'normal',
    fontWeight: 'bold',
    lineHeight: '24px',
    fontFeatureSettings: "'pnum' on, 'lnum' on",
    color: `#3A3A3A`,
    whiteSpace: 'nowrap',
    textWrap: 'wrap',
    overflowWrap: 'anywhere',
    '& > small': {
        color: '#d32f2f',
        fontSize: '8px',
        wordBreak: 'break-all',
    },
};

export const uploadZonestyleParentUploadZone = {
    border: '2px dashed #222754',
    borderRadius: '6px',
    textAlign: 'center',
    background: '#F6F6F6',
};

export const uploadZonestyleChildUploadZone = {
    overflowY: 'auto',
    height: 'calc(100vh - 19rem)',
    borderBottom: '1px solid',
    padding: '0 2rem',
};

export const uploadZonestyleFileData = {
    borderRadius: '10px',
    background: 'white',
};

export const uploadZonestyleUploadBox = {
    padding: '1rem 2rem',
    display: 'flex',
    justifyContent: 'space-between',
    margin: `1rem 0`,
    minHeight: '5rem',
    border: ``,
    borderRadius: '10px',
};

export const uploadZonestyleRemoveRedIcon: CSSProperties = {
    position: 'absolute',
    right: '-3rem',
    top: '-2rem',
    cursor: 'pointer',
};

export const uploadZonestyleFileTranslageBg = {
    position: 'relative',
    top: '50%',
    transform: 'translateY(-50%)',
    maxWidth: '300px',
};

export const uploadZonestyleBoxButton = {
    display: 'flex',
    gap: '2rem',
    flexFlow: 'wrap',
    maxWidth: '35rem',
    padding: '1rem 1rem',
    '& > button.MuiButton-root': {
        width: '200px',
    },
};

export const uploadZoneTypographyErrorHelper = {
    color: '#d32f2f',
    fontSize: '11px',
    wordBreak: 'break-all',
};
